import { IDepartmentDTO } from 'src/api/dtos';
import { DepartmentDisplayFormatEnums } from 'src/shared/enums';

export const formatDepartmentDisplay = (
  description: IDepartmentDTO['description'],
  number: IDepartmentDTO['number'] | number,
  format: DepartmentDisplayFormatEnums = DepartmentDisplayFormatEnums.NUMBER_DESCRIPTION,
): string => {
  switch (format) {
    case DepartmentDisplayFormatEnums.DESCRIPTION:
      return `${description}`;
    case DepartmentDisplayFormatEnums.DESCRIPTION_NUMBER:
      return `${description} - ${number}`;
    case DepartmentDisplayFormatEnums.NUMBER:
      return `${number}`;
    case DepartmentDisplayFormatEnums.NUMBER_DESCRIPTION:
    default:
      return `${number} - ${description}`;
  }
};
